module.exports = __webpack_public_path__ + "img/safari.03e05c64.png";